// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationItem-module_notification_u4-GA","delete":"NotificationItem-module_delete_1dokg"};